import { Controller } from "@hotwired/stimulus"

// The filename beside FileFieldComponent's button. Hiding the native input takes away the one
// piece of feedback it gave for free - "photo.jpg" next to the browser's own button - so this
// puts it back. Whatever is already on the server is server-rendered (true with this asleep);
// this only speaks up once a new pick would replace it on submit.
export default class extends Controller {
  static targets = ["filename"]

  update(event) {
    const file = event.target.files[0]
    if (!file) return

    this.filenameTarget.textContent = file.name
    this.filenameTarget.classList.remove("hidden")
  }
}
